import { Component, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import * as CourseActions from '../shared/core/state/course/course.actions';

@Component({
    selector: 'black-courses',
    templateUrl: './courses.component.html',
    styleUrls: ['./courses.component.css'],
    standalone: false
})
export class CoursesComponent implements OnInit {
  private store = inject(Store);


  ngOnInit(): void {
  }
}
